<template>
  <card
    title="מכשירים שלא אומתו"
    :linkTo="`/orders?deviceValidation=false&orderStatuses=${bookedOutStatusId}&startDateBefore=${format(subDays(Date(), 1), 'YYYY-MM-DD')}`"
    actionButton="לכל המכשירים שלא אמותו"
    :number="number"
    :loading="loading"
    :error="error"
  />
</template>

<script>
import { format, subDays } from 'date-fns';
import { getApi } from '@/api';
import Card from "./Card.vue";

export default {
  data() {
    return {
      number: 0,
      loading: false,
      error: false
    };
  },

  computed: {
    bookedOutStatusId() {
      let bookedOutStatus = Object.values(this.$store.state.entities.orderStatuses).find(item => {
        return item.key === 'BOOKED_OUT';
      })
      return bookedOutStatus ? bookedOutStatus._id : null;
    }
  },

  methods: {
    format,
    subDays,
    fetchData() {
      this.loading = true;
      getApi()
        .then(api => {
          let params = {
            startDateBefore: format(subDays(Date(), 1), 'YYYY-MM-DD'),
            orderStatuses: this.bookedOutStatusId,
            deviceValidation: false
          };
          return api.get('/orders', { params })
        })
        .then(({ data }) => {
          this.number = data.totalResults;
        })
        .catch(err => {
          console.log(err);
          this.error = true;
        })
        .finally(() => {
          this.loading = false;
        })
    }
  },

  props: [],

  mounted() {
    this.fetchData();
  },

  components: {
    Card
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
